// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"681":"d152aec7","1874":"6a1e7119","5899":"31d6cfe0","7655":"4bdd9d72"}[chunkId] + ".chunk.css";
};